import { useState, useEffect } from 'react'
import moment from 'moment'
import { faChevronDown, faChevronUp, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../viewRequest.css'

const OHViewRequest = ({ viewingRequest }) => {
    const [activityLogItems, setActivityLogItems] = useState(null)
    const [isAccordionOpen, setAccordionOpen] = useState(false)
    const [requestItems, setRequestItems] = useState(null)

    useEffect(() => {
        if (viewingRequest?.activity_log) {
            const activityLog =
                typeof viewingRequest.activity_log === 'string'
                    ? JSON.parse(viewingRequest.activity_log)
                    : viewingRequest.activity_log

            setActivityLogItems(activityLog)
        }

        if (viewingRequest?.request_info_array) {
            setRequestItems(viewingRequest.request_info_array)
        } else if (viewingRequest?.request_information) {
            const requestInfo =
                typeof viewingRequest.request_information === 'string'
                    ? JSON.parse(viewingRequest.request_information)
                    : viewingRequest.request_information

            setRequestItems(requestInfo)
        }
    }, [viewingRequest])

    const toggleAccordion = () => {
        setAccordionOpen(!isAccordionOpen)
    }

    const getStatusStyle = (status) => {
        const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium'

        switch (status?.toLowerCase()) {
            case 'pending':
                return `${baseClasses} bg-yellow-100 text-yellow-800`
            case 'in progress':
            case 'in_progress':
                return `${baseClasses} bg-blue-100 text-blue-800`
            case 'completed':
                return `${baseClasses} bg-green-100 text-green-800`
            case 'cancelled':
            case 'canceled':
                return `${baseClasses} bg-red-100 text-red-800`
            case 'on hold':
            case 'on_hold':
                return `${baseClasses} bg-gray-100 text-gray-800`
            default:
                return `${baseClasses} bg-gray-100 text-gray-800`
        }
    }

    const handleDownload = async () => {
        try {
            let fileName = requestItems.filename.replace('/pdf/oh-result/', '')
            window
                .open(
                    `${process.env.REACT_APP_KIS}/download-decrypted-file/` + fileName,
                    '_blank'
                )
                .focus()
        } catch (error) {
            console.error('Error downloading the file', error)
        }
    }

    const renderFormResponses = () => {
        if (!requestItems?.form_responses) return null

        const responses = typeof requestItems.form_responses === 'string'
            ? JSON.parse(requestItems.form_responses)
            : requestItems.form_responses

        return (
            <div className="space-y-6">
                {responses.question1 && (
                    <div className="border-l-4 border-gray-300 pl-4">
                        <h4 className="font-semibold text-gray-900 mb-3 text-base">{responses.question1.question_title || 'Question 1: Support Reason'}</h4>
                        <div className="bg-gray-50 p-3 rounded-md space-y-2 text-sm">
                            {responses.question1.responses && Object.entries(responses.question1.responses).map(([key, item]) => (
                                <div key={key} className="flex">
                                    <span className="font-medium text-gray-700 min-w-0 flex-shrink-0 w-1/3">{item.label}:</span>
                                    <span className="text-gray-900 ml-2 flex-1">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {responses.question2 && (
                    <div className="border-l-4 border-gray-300 pl-4">
                        <h4 className="font-semibold text-gray-900 mb-3 text-base">{responses.question2.question_title || 'Question 2: Issue Nature'}</h4>
                        <div className="bg-gray-50 p-3 rounded-md space-y-2 text-sm">
                            {responses.question2.responses && Object.entries(responses.question2.responses).map(([key, item]) => (
                                <div key={key} className="flex">
                                    <span className="font-medium text-gray-700 min-w-0 flex-shrink-0 w-1/3">{item.label}:</span>
                                    <span className="text-gray-900 ml-2 flex-1">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {responses.question3 && (
                    <div className="border-l-4 border-gray-300 pl-4">
                        <h4 className="font-semibold text-gray-900 mb-3 text-base">{responses.question3.question_title || 'Question 3: Meetings and Outcomes'}</h4>
                        <div className="bg-gray-50 p-3 rounded-md space-y-2 text-sm">
                            {responses.question3.responses && Object.entries(responses.question3.responses).map(([key, item]) => (
                                <div key={key} className="flex">
                                    <span className="font-medium text-gray-700 min-w-0 flex-shrink-0 w-1/3">{item.label}:</span>
                                    <span className="text-gray-900 ml-2 flex-1">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {responses.question4 && (
                    <div className="border-l-4 border-gray-300 pl-4">
                        <h4 className="font-semibold text-gray-900 mb-3 text-base">{responses.question4.question_title || 'Question 4: Actions Implemented'}</h4>
                        <div className="bg-gray-50 p-3 rounded-md space-y-2 text-sm">
                            {responses.question4.responses && Object.entries(responses.question4.responses).map(([key, item]) => (
                                <div key={key} className="flex">
                                    <span className="font-medium text-gray-700 min-w-0 flex-shrink-0 w-1/3">{item.label}:</span>
                                    <span className="text-gray-900 ml-2 flex-1">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {responses.question5 && (
                    <div className="border-l-4 border-gray-300 pl-4">
                        <h4 className="font-semibold text-gray-900 mb-3 text-base">{responses.question5.question_title || 'Question 5: Intended Outcome'}</h4>
                        <div className="bg-gray-50 p-3 rounded-md space-y-2 text-sm">
                            {responses.question5.responses && Object.entries(responses.question5.responses).map(([key, item]) => (
                                <div key={key} className="flex">
                                    <span className="font-medium text-gray-700 min-w-0 flex-shrink-0 w-1/3">{item.label}:</span>
                                    <span className="text-gray-900 ml-2 flex-1">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {responses.question6 && (
                    <div className="border-l-4 border-gray-300 pl-4">
                        <h4 className="font-semibold text-gray-900 mb-3 text-base">{responses.question6.question_title || 'Question 6: Additional Information'}</h4>
                        <div className="bg-gray-50 p-3 rounded-md space-y-2 text-sm">
                            {responses.question6.responses && Object.entries(responses.question6.responses).map(([key, item]) => (
                                <div key={key} className="flex">
                                    <span className="font-medium text-gray-700 min-w-0 flex-shrink-0 w-1/3">{item.label}:</span>
                                    <span className="text-gray-900 ml-2 flex-1">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 pb-4">
                <div className="flex items-center justify-between mb-3">
                    <h2 className="text-lg font-semibold text-gray-900">
                        Occupational Health Request
                    </h2>
                    <span className={getStatusStyle(viewingRequest?.request_status)}>
                        {viewingRequest?.request_status || 'Unknown'}
                    </span>
                </div>

                <div className="grid grid-cols-2 gap-6 text-sm">
                    <div>
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Reference</div>
                        <div className="font-mono text-gray-900">{viewingRequest?.reference || 'N/A'}</div>
                    </div>
                    <div>
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Type</div>
                        <div className="text-gray-900">Occupational Health Request</div>
                    </div>
                </div>

                {viewingRequest?.description && (
                    <div className="text-sm mt-4">
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Description</div>
                        <div className="text-gray-900">{viewingRequest.description}</div>
                    </div>
                )}
            </div>            <div className="border-b border-gray-200 pb-4">
                <h3 className="font-medium text-gray-900 mb-3">
                    Staff Details
                </h3>
                <div className="grid grid-cols-3 gap-6 text-sm">
                    <div>
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Name</div>
                        <div className="text-gray-900">
                            {(() => {
                                try {
                                    const requestInfo = typeof viewingRequest?.request_information === 'string'
                                        ? JSON.parse(viewingRequest.request_information)
                                        : viewingRequest?.request_information
                                    return requestInfo?.staff_details?.staff_name || 'N/A'
                                } catch (e) {
                                    return 'N/A'
                                }
                            })()}
                        </div>
                    </div>

                    <div>
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Date of Birth</div>
                        <div className="text-gray-900">
                            {(() => {
                                try {
                                    const requestInfo = typeof viewingRequest?.request_information === 'string'
                                        ? JSON.parse(viewingRequest.request_information)
                                        : viewingRequest?.request_information
                                    const dob = requestInfo?.staff_details?.date_of_birth
                                    return dob ? moment(dob).format('DD/MM/YYYY') : 'N/A'
                                } catch (e) {
                                    return 'N/A'
                                }
                            })()}
                        </div>
                    </div>

                    <div>
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Email</div>
                        <div className="text-gray-900 break-all">
                            {(() => {
                                try {
                                    const requestInfo = typeof viewingRequest?.request_information === 'string'
                                        ? JSON.parse(viewingRequest.request_information)
                                        : viewingRequest?.request_information
                                    return requestInfo?.staff_details?.staff_email || 'N/A'
                                } catch (e) {
                                    return 'N/A'
                                }
                            })()}
                        </div>
                    </div>
                </div>
            </div>            <div className="border-b border-gray-200 pb-4">
                <h3 className="font-medium text-gray-900 mb-3">
                    Form Responses
                </h3>
                <div className="text-sm">
                    {renderFormResponses()}
                </div>
            </div>

            <div className="border-b border-gray-200 pb-4">
                <div className="mb-4 flex items-center justify-between">
                    <div className="mb-4 flex items-center">
                        <h3 className="font-medium text-gray-900">Activity Log</h3>
                        <button
                            onClick={toggleAccordion}
                            className="ml-2 text-indigo-900 hover:underline"
                        >
                            <FontAwesomeIcon
                                icon={isAccordionOpen ? faChevronUp : faChevronDown}
                                className="h-4 w-4 focus:border-none"
                            />
                        </button>
                    </div>
                </div>
                {isAccordionOpen && (
                    <div className="pl-6">
                        {activityLogItems &&
                            (Array.isArray(activityLogItems)
                                ? activityLogItems.length > 0
                                : Object.keys(activityLogItems).length > 0) ? (
                            <ol className="relative border-s">
                                {(Array.isArray(activityLogItems)
                                    ? activityLogItems
                                    : [activityLogItems]
                                ).map((log, index) => (
                                    <li className="mb-6 flex items-center" key={index}>
                                        <span className="absolute flex items-center justify-center w-5 h-5 bg-[#02ADAD] rounded-full -start-3 ring-4 ring-white"></span>
                                        <div className="ml-6">
                                            <h3 className="mb-1 text-base font-semibold text-gray-900">
                                                {log.title}
                                            </h3>
                                            <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
                                                {moment(log.timestamp).format('DD/MM/YYYY HH:mm:ss')}
                                            </time>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        ) : (
                            <ol className="relative border-s ">
                                <li className="mb-10 ms-6">
                                    <span className="absolute flex items-center justify-center w-5 h-5 bg-[#02ADAD] rounded-full -start-3 ring-4 ring-white"></span>
                                    <h3 className="flex items-center mb-1 text-base font-semibold text-gray-900">
                                        No Activity Log Data
                                    </h3>
                                    <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
                                        {moment().format('DD/MM/YYYY HH:mm:ss')}
                                    </time>
                                </li>
                            </ol>
                        )}
                    </div>
                )}
            </div>

            {requestItems?.filename && (
                <div>
                    <h3 className="font-medium text-gray-900 mb-3">
                        Documents
                    </h3>
                    <div className="flex items-center justify-between border-l-2 border-gray-200 pl-4 py-2">
                        <div>
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Document</div>
                            <div className="text-sm text-gray-900">OH Results Document</div>
                        </div>
                        <button
                            onClick={handleDownload}
                            className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                        >
                            <FontAwesomeIcon icon={faDownload} className="mr-1 h-3 w-3" />
                            <span className="text-sm">Download</span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default OHViewRequest